import { render, staticRenderFns } from "./SalesTables.vue?vue&type=template&id=7f310910&"
import script from "./SalesTables.vue?vue&type=script&lang=ts&"
export * from "./SalesTables.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports